import CoreApis from './core';
import DashboardApis from './dashboard';
import RoleApis from './roles';
import SessionApis from './session';
import GroupsApis from './group';
import UserApis from './users';
import PermissionsApi from './permissions';
import CannedMessagesApi from './canned_messages';
import ContactBookApis from './contact_book';
import ContactGroupApis from './contact_group';
import Template from './template';
import ContentApis from './content';
import AttachmentApis from './attachments';
import ConversationsApi from './conversations';
import ForgetPasswordApi from './forgetPassword';
import CampaignApis from './campaigns';
import Reports from './reports';
import ProfileApis from './profile';
import LocationApis from './locations';
import CustomerOnBoard from './customerOnBoard';
import Business from './onBoarding/business';
import BusinessDetails from './onBoarding/businessDetails';
import CompanyStats from './onBoarding/companyStats';
import CompanyAgent from './onBoarding/companyAgent';
import Otp from './otp';
import surveyReport from './surveyReport/index';
import counts from './chatCounts';
import agentHandlingTime from './agentHandlingTime';
import historyNumbers from './conversations';
import clientInfo from './onBoarding/companyStats';
import templateConfig from './templateConfig';
import themeConfigs from './themeConfigs';
import templateMessagesMFMS from './templateMessagesMFMS';
import chatsidePannel from './chatsidePannel';
import FlagApis from './flag';
import Mau from './mau';
import Catalogues from './catalogues';
import Products from './products';
import AdminChatbot from './admin_chatbot';
import Tickets from './tickets';
import Complain from './complain/index';
import channels from './channels';
import tagsforchatbot from './tagsforchatbot';
import nearestLocations from './nearestLocations';
import reminderMsg from './reminderMsg';
import segments from './segments';
import shellCustomer from './shellCustomer';
import lemonMaxCustomer from './lemonMaxCustomer';
import uatCustomer from './uatCustomer';
import agentsTemplate from './agentsTemplate';
import sms from './sms';
import blacklistToken from './blacklistToken';
import billing from './billing';
import numbers from './numbers';
import active_sessions from './active_sessions';
import login_otp from './login_otp';
import ipWhitelist from './ipWhitelist';
import clientWebhook from './clientWebhook';
import labels from './labels';
import accountsLimits from './accountsLimits';
import analytics from './analytics';
import customers from './chatbotAnalytics';
import emailCampaign from './emailCampaign';
import phoneValidation from './phoneValidation';
import customerJourney from './customerJourney';
import voicePortal from './voicePortal';
import systemPermissions from './systemPermissions';
import saChannels from './saChannels';
import swichPaymentConfiguration from './swichPaymentConfiguration';
import facebookPosts from './facebookPosts';
import pbx from './pbx';
import creditLine from './creditLine';
import messageLimitsAndQuotaManagement from './messageLimitsAndQuotaManagement';
import notifications from './notifications';
import admin_chatbot from './admin_chatbot';
import chatbot_calls from './chatbot_calls';
import elevenLabsAgents from './elevenLabsAgents';
import emailInbox from './emailInbox';
import messagesCounts from './messagesCounts';
import aiCallProvider from './aiCallProvider';
import aiCallConfig from './aiCallConfig';
import elevenLabsAgent from './elevenLabsAgent';
import dynamicBanner from './dynamicBanner';
import emailAccountLimit from './emailAccountLimit';
import campaignApprovals from './campaignApprovals';
import tiktok from './tiktok';
import web from './web';

class ApiResolver {
	constructor() {
		this.apis = {
			CompanyAgent: CompanyAgent.apis(),
			CompanyStats: CompanyStats.apis(),
			Business: Business.apis(),
			BusinessDetails: BusinessDetails.apis(),
			customerOnBoard: CustomerOnBoard.apis(),
			core: CoreApis.apis(),
			dashboard: DashboardApis.apis(),
			roles: RoleApis.apis(),
			session: SessionApis.apis(),
			users: UserApis.apis(),
			otp: Otp.apis(),
			groups: GroupsApis.apis(),
			permissions: PermissionsApi.apis(),
			conversations: ConversationsApi.apis(),
			attachments: AttachmentApis.apis(),
			canned_messages: CannedMessagesApi.apis(),
			contact_book: ContactBookApis.apis(),
			contact_group: ContactGroupApis.apis(),
			template: Template.apis(),
			content: ContentApis.apis(),
			campaigns: CampaignApis.apis(),
			forgetpassword: ForgetPasswordApi.apis(),
			reports: Reports.apis(),
			profile: ProfileApis.apis(),
			locations: LocationApis.apis(),
			surveyReport: surveyReport.apis(),
			chatsCount: counts.apis(),
			agentHandlingTime: agentHandlingTime.apis(),
			historyNumbers: historyNumbers.apis(),
			clientInfo: clientInfo.apis(),
			convoHourly: DashboardApis.apis(),
			templateConfig: templateConfig.apis(),
			monthlyMau: Reports.apis(),
			customerJourney: Reports.apis(),
			monthlyMauSuper: Reports.apis(),
			themeConfigs: themeConfigs.apis(),
			templateMessagesMFMS: templateMessagesMFMS.apis(),
			chatsidePannel: chatsidePannel.apis(),
			flag: FlagApis.apis(),
			mau: Mau.apis(),
			catalogues: Catalogues.apis(),
			products: Products.apis(),
			admin_chatbot: AdminChatbot.apis(),
			tickets: Tickets.apis(),
			complain: Complain.apis(),
			channels: channels.apis(),
			tagsforchatbot: tagsforchatbot.apis(),
			nearestLocations: nearestLocations.apis(),
			reminderMsg: reminderMsg.apis(),
			segments: segments.apis(),
			labels: labels.apis(),
			shellCustomer: shellCustomer.apis(),
			lemonMaxCustomer: lemonMaxCustomer.apis(),
			uatCustomer: uatCustomer.apis(),
			agentsTemplate: agentsTemplate.apis(),
			sms: sms.apis(),
			blacklistToken: blacklistToken.apis(),
			accountsLimits: accountsLimits.apis(),
			billing: billing.apis(),
			numbers: numbers.apis(),
			active_sessions: active_sessions.apis(),
			login_otp: login_otp.apis(),
			ipWhitelist: ipWhitelist.apis(),
			clientWebhook: clientWebhook.apis(),
			analytics: analytics.apis(),
			customers: customers.apis(),
			emailCampaign: emailCampaign.apis(),
			phoneValidation: phoneValidation.apis(),
			customerJourney: customerJourney.apis(),
			voicePortal: voicePortal.apis(),
			systemPermissions: systemPermissions.apis(),
			saChannels: saChannels.apis(),
			swichPaymentConfiguration: swichPaymentConfiguration.apis(),
			pbx: pbx.apis(),
			creditLine: creditLine.apis(),
			messageLimitsAndQuotaManagement: messageLimitsAndQuotaManagement.apis(),
			facebookPosts: facebookPosts.apis(),
			notifications: notifications.apis(),
			admin_chatbot: admin_chatbot.apis(),
			chatbot_calls: chatbot_calls.apis(),
			elevenLabsAgents: elevenLabsAgents.apis(),
			emailInbox: emailInbox.apis(),
			messagesCounts: messagesCounts.apis(),
			aiCallProvider: aiCallProvider.apis(),
			aiCallConfig: aiCallConfig.apis(),
			elevenLabsAgent: elevenLabsAgent.apis(),
			dynamicBanner: dynamicBanner.apis(),
			campaignApprovals: campaignApprovals.apis(),
			tiktok: tiktok.apis(),
			web: web.apis(),
			emailAccountLimit: emailAccountLimit.apis(),
			campaignApprovals: campaignApprovals.apis()
		};
	}

	resolve(name, apiCall) {
		if (!this.apis[name]) throw new Error(`Failed to resolve api [${name}]`);

		if (!this.apis[name][apiCall]) throw new Error(`Failed to resolve api call [${apiCall}]`);

		return this.apis[name][apiCall];
	}
}

export default new ApiResolver();
